export const defaultTheme = {
  lightMode: {
    aboutAppIcon:
      'https://cdn.jawwal.ps/api/Content/1661847387/GeneralContents/_/Ar/Aboutapp_Mass',
    PUKIcon:
      'https://cdn.jawwal.ps/api/Content/1661847680/GeneralContents/_/Ar/PUK_Mass',
    internetSettingsIcon:
      'https://cdn.jawwal.ps/api/Content/1661088836/GeneralContents/_/Ar/Internet_Settings_Mass',
    noBillsIcon:
      'https://cdn.jawwal.ps/api/Content/1661431595/GeneralContents/_/Ar/NoBills_Mass',
    switchIcon:
      'https://cdn.jawwal.ps/api/Content/1661089230/GeneralContents/_/Ar/Switch_Mass',
    internetOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662822539/GeneralContents/_/Ar/InternetOffers_Mass',
    callOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662822819/GeneralContents/_/Ar/CallsOffers_Mass',
    comboOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662823909/GeneralContents/_/Ar/ComboOffers_Mass',
    hotOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662823565/GeneralContents/_/Ar/HotOffers_Mass',
    SMSOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662823318/GeneralContents/_/Ar/SMSOffers_Mass',
    otherOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662824148/GeneralContents/_/Ar/OtherOffers_Mass',
    noResultIcon:
      'https://cdn.jawwal.ps/api/Content/1663664803/GeneralContents/_/Ar/NoResult_Mass',
    TRXHistoryIcon:
      'https://cdn.jawwal.ps/api/Content/1663665320/GeneralContents/_/Ar/Trx_Mass',
    RoamingIcon:
      'https://cdn.jawwal.ps/api/Content/1678196867/GeneralContents/_/Ar/Roaming_Mass_Light',
    InternationalIcon:
      'https://cdn.jawwal.ps/api/Content/1661436010/GeneralContents/_/Ar/International_Mass',
    balanceHistory:
      'https://cdn.jawwal.ps/api/Content/1678868772/GeneralContents/_/Ar/Balance_History_Mass',
    filterBalanceIcon:
      'https://cdn.jawwal.ps/api/Content/1678967965/GeneralContents/_/Ar/Balance_History_Filter',
    callmebackIcon:
      'https://cdn.jawwal.ps/api/Content/1666774077/GeneralContents/_/Ar/CMB_Mass',
    barringCalls:
    'https://cdn.jawwal.ps/api/Content/1732106468/GeneralContents/_/Ar/Calls_Barring',
    directDebtIcon:
      'https://cdn.jawwal.ps/api/Content/1727246929/GeneralContents/_/Ar/Direct_Debit',
    wifiSettingsIcon:
      'https://cdn.jawwal.ps/api/Content/1725778696/GeneralContents/_/En/Router_Settings',
    messengerIcon:
    'https://cdn.jawwal.ps/api/Content/1735553789/GeneralContents/_/Ar/Messenger',
    servicePayBillsForOthersIcon: 
    'https://cdn.jawwal.ps/api/Content/1756634452/GeneralContents/_/Ar/Pay_Bills_Others'
  },
  darkMode: {
    aboutAppIcon:
      'https://cdn.jawwal.ps/api/Content/1661847457/GeneralContents/_/Ar/Aboutapp_Mass_Dark',
    PUKIcon:
      'https://cdn.jawwal.ps/api/Content/1661847766/GeneralContents/_/Ar/PUK_Mass_Dark',
    internationalCallsIcon:
      'https://cdn.jawwal.ps/api/Content/1661432476/GeneralContents/_/Ar/International_Mass_Dark',
    internetSettingsIcon:
      'https://cdn.jawwal.ps/api/Content/1661430216/GeneralContents/_/Ar/InternetSettings_Mass_Dark',
    noBillsIcon:
      'https://cdn.jawwal.ps/api/Content/1661431661/GeneralContents/_/Ar/NoBills_Mass_Dark',
    switchIcon:
      'https://cdn.jawwal.ps/api/Content/1661430703/GeneralContents/_/Ar/Switch_Mass_Dark',
    internetOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662822673/GeneralContents/_/Ar/InternetOffers_Mass_Dark',
    callOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662822968/GeneralContents/_/Ar/CallsOffers_Mass_Dark',
    comboOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662824005/GeneralContents/_/Ar/ComboOffers_Mass_Dark',
    hotOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662823663/GeneralContents/_/Ar/HotOffers_Mass_Dark',
    SMSOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662823416/GeneralContents/_/Ar/SMSOffers_Mass_Dark',
    otherOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662824263/GeneralContents/_/Ar/OtherOffers_Mass_Dark',
    noResultIcon:
      'https://cdn.jawwal.ps/api/Content/1663665018/GeneralContents/_/Ar/NoResult_Mass_Dark',
    TRXHistoryIcon:
      'https://cdn.jawwal.ps/api/Content/1663665449/GeneralContents/_/Ar/Trx_Mass_Dark',
    RoamingIcon:
      'https://cdn.jawwal.ps/api/Content/1678197092/GeneralContents/_/Ar/Roaming_Mass_Dark',
    InternationalIcon:
      'https://cdn.jawwal.ps/api/Content/1664695943/GeneralContents/_/Ar/International_Mass_Dark',
    balanceHistory:
      'https://cdn.jawwal.ps/api/Content/1678868772/GeneralContents/_/Ar/Balance_History_Mass',
    filterBalanceIcon:
      'https://cdn.jawwal.ps/api/Content/1678967965/GeneralContents/_/Ar/Balance_History_Filter',
    callmebackIcon:
      'https://cdn.jawwal.ps/api/Content/1666774077/GeneralContents/_/Ar/CMB_Mass',
    barringCalls :
    'https://cdn.jawwal.ps/api/Content/1732106468/GeneralContents/_/Ar/Calls_Barring',
    directDebtIcon :
    'https://cdn.jawwal.ps/api/Content/1727246929/GeneralContents/_/Ar/Direct_Debit',
    wifiSettingsIcon :
      'https://cdn.jawwal.ps/api/Content/1725778696/GeneralContents/_/En/Router_Settings',
    messengerIcon :
    'https://cdn.jawwal.ps/api/Content/1735553789/GeneralContents/_/Ar/Messenger',
    servicePayBillsForOthersIcon: 
    'https://cdn.jawwal.ps/api/Content/1756634452/GeneralContents/_/Ar/Pay_Bills_Others'
  },
}

export const youthTheme = {
  lightMode: {
    aboutAppIcon:
      'https://cdn.jawwal.ps/api/Content/1661429299/GeneralContents/_/Ar/AboutApp_Youth',
    PUKIcon:
      'https://cdn.jawwal.ps/api/Content/1661429107/GeneralContents/_/Ar/PUK_Youth',
    internationalCallsIcon:
      'https://cdn.jawwal.ps/api/Content/1661432206/GeneralContents/_/Ar/International_Youth',
    internetSettingsIcon:
      'https://cdn.jawwal.ps/api/Content/1661430341/GeneralContents/_/Ar/InternetSettings_Youth',

    noBillsIcon:
      'https://cdn.jawwal.ps/api/Content/1661431729/GeneralContents/_/Ar/NoBills_Youth',
    switchIcon:
      'https://cdn.jawwal.ps/api/Content/1661430787/GeneralContents/_/Ar/Switch_Youth',
    internetOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662825326/GeneralContents/_/Ar/InternetOffers_Youth',
    callOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662825509/GeneralContents/_/Ar/CallsOffers_Youth',
    comboOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662824718/GeneralContents/_/Ar/ComboOffers_Youth',
    hotOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662824918/GeneralContents/_/Ar/HotOffers_Youth',
    SMSOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662825091/GeneralContents/_/Ar/SMSOffers_Youth',
    otherOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662824539/GeneralContents/_/Ar/OtherOffers_Youth',
    noResultIcon:
      'https://cdn.jawwal.ps/api/Content/1663658254/GeneralContents/_/Ar/NoResult_Youth',
    TRXHistoryIcon:
      'https://cdn.jawwal.ps/api/Content/1663658436/GeneralContents/_/Ar/Trx_Youth',
    RoamingIcon:
      'https://cdn.jawwal.ps/api/Content/1678194253/GeneralContents/_/Ar/Roaming_Youth_Light',
    InternationalIcon:
      'https://cdn.jawwal.ps/api/Content/1661435806/GeneralContents/_/En/International_Youth',
    balanceHistory:
      'https://cdn.jawwal.ps/api/Content/1678877358/GeneralContents/_/Ar/Balance_History_Youth',
    filterBalanceIcon:
      'https://cdn.jawwal.ps/api/Content/1678967965/GeneralContents/_/Ar/Balance_History_Filter',
    callmebackIcon:
      'https://cdn.jawwal.ps/api/Content/1666774077/GeneralContents/_/Ar/CMB_Youth',
  },
  darkMode: {
    aboutAppIcon:
      'https://cdn.jawwal.ps/api/Content/1661429375/GeneralContents/_/Ar/AboutApp_Youth_Dark',
    PUKIcon:
      'https://cdn.jawwal.ps/api/Content/1661429186/GeneralContents/_/Ar/PUK_Youth_Dark',
    internationalCallsIcon:
      'https://cdn.jawwal.ps/api/Content/1661432335/GeneralContents/_/Ar/International_Youth_Dark',
    internetSettingsIcon:
      'https://cdn.jawwal.ps/api/Content/1661430439/GeneralContents/_/Ar/InternetSettings_Youth_Dark',
    noBillsIcon:
      'https://cdn.jawwal.ps/api/Content/1661431805/GeneralContents/_/Ar/NoBills_Youth_Dark',
    switchIcon:
      'https://cdn.jawwal.ps/api/Content/1661430853/GeneralContents/_/Ar/Switch_Youth_Dark',
    internetOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662825423/GeneralContents/_/Ar/InternetOffers_Youth_Dark',
    callOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662825609/GeneralContents/_/Ar/CallsOffers_Youth_Dark',
    comboOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1663060011/GeneralContents/_/Ar/ComboOffers_Youth_Dark',
    hotOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1663060057/GeneralContents/_/Ar/HotOffers_Youth_Dark',
    SMSOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662825168/GeneralContents/_/Ar/SMSOffers_Youth_Dark',
    otherOffersIcon:
      'https://cdn.jawwal.ps/api/Content/1662824637/GeneralContents/_/Ar/OtherOffers_Youth_Dark',
    noResultIcon:
      'https://cdn.jawwal.ps/api/Content/1663658332/GeneralContents/_/Ar/NoResult_Youth_Dark',
    TRXHistoryIcon:
      'https://cdn.jawwal.ps/api/Content/1663658507/GeneralContents/_/Ar/Trx_Youth_Dark',
    RoamingIcon:
      'https://cdn.jawwal.ps/api/Content/1678194253/GeneralContents/_/Ar/Roaming_Youth_Dark',
    InternationalIcon:
      'https://cdn.jawwal.ps/api/Content/1664695943/GeneralContents/_/Ar/International_Youth_Dark',
    balanceHistory:
      'https://cdn.jawwal.ps/api/Content/1678877358/GeneralContents/_/Ar/Balance_History_Youth',
    filterBalanceIcon:
      'https://cdn.jawwal.ps/api/Content/1678967965/GeneralContents/_/Ar/Balance_History_Filter',
    callmebackIcon:
      'https://cdn.jawwal.ps/api/Content/1666774077/GeneralContents/_/Ar/CMB_Youth',
  },
}

/** Fallback shell for fixed-line theme merge; asset URLs come from the API (`result.theme`). */
export const defaultPaltelTheme = {
  lightMode: {},
  darkMode: {},
}
